import _asyncToGenerator from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/codebuild/output/src3701839561/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { getDnsSuffix } from '../../clients/endpoints/getDnsSuffix.mjs';
import { unauthenticatedHandler } from '../../clients/handlers/unauthenticated.mjs';
import { jitteredBackoff } from '../../clients/middleware/retry/jitteredBackoff.mjs';
import { getRetryDecider } from '../../clients/middleware/retry/defaultRetryDecider.mjs';
import '@aws-crypto/sha256-js';
import '@smithy/util-hex-encoding';
import { AmplifyUrl } from '../../utils/amplifyUrl/index.mjs';
import { composeTransferHandler } from '../../clients/internal/composeTransferHandler.mjs';
import { parseJsonError } from '../../clients/serde/json.mjs';
import { getAmplifyUserAgent } from '../../Platform/index.mjs';
import { observeFrameworkChanges } from '../../Platform/detectFramework.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * The service name used to sign requests if the API requires authentication.
 */

var SERVICE_NAME = 'cognito-identity';
/**
 * The endpoint resolver function that returns the endpoint URL for a given region.
 */

var endpointResolver = function endpointResolver(_ref) {
  var region = _ref.region;
  return {
    url: new AmplifyUrl("https://cognito-identity.".concat(region, ".").concat(getDnsSuffix(region)))
  };
};
/**
 * A Cognito Identity-specific middleware that disables caching for all requests.
 */


var disableCacheMiddlewareFactory = function disableCacheMiddlewareFactory() {
  return function (next) {
    return /*#__PURE__*/function () {
      var _disableCacheMiddleware = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                request.headers['cache-control'] = 'no-store';
                return _context.abrupt("return", next(request));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function disableCacheMiddleware(_x) {
        return _disableCacheMiddleware.apply(this, arguments);
      }

      return disableCacheMiddleware;
    }();
  };
};
/**
 * A Cognito Identity-specific transfer handler that does NOT sign requests, and
 * disables caching.
 *
 * @internal
 */


var cognitoIdentityTransferHandler = composeTransferHandler(unauthenticatedHandler, [disableCacheMiddlewareFactory]);
/**
 * @internal
 */

var defaultConfig = {
  service: SERVICE_NAME,
  endpointResolver: endpointResolver,
  retryDecider: getRetryDecider(parseJsonError),
  computeDelay: jitteredBackoff,
  userAgentValue: getAmplifyUserAgent(),
  cache: 'no-store'
};
observeFrameworkChanges(function () {
  defaultConfig.userAgentValue = getAmplifyUserAgent();
});
/**
 * @internal
 */

var getSharedHeaders = function getSharedHeaders(operation) {
  return {
    'content-type': 'application/x-amz-json-1.1',
    'x-amz-target': "AWSCognitoIdentityService.".concat(operation)
  };
};
/**
 * @internal
 */


var buildHttpRpcRequest = function buildHttpRpcRequest(_ref2, headers, body) {
  var url = _ref2.url;
  return {
    headers: headers,
    url: url,
    body: body,
    method: 'POST'
  };
};

export { buildHttpRpcRequest, cognitoIdentityTransferHandler, defaultConfig, getSharedHeaders };